// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --bar-width: calc(100vw - 45px);
}

.rating {
  background-color: #FFFFFF;
  border: var(--ion-color-light-tint) 1px solid;
  padding-top: 1px;
  border-radius: 15px;
  padding-left: 15px;
  padding-right: 15px;
}
.rating p {
  width: 100%;
  text-align: center;
  margin: 5px 0;
  font-size: 12px;
  color: var(--ion-color-text-color);
}

.rating-box {
  border-radius: 15px;
  background: var(--planeed-color-white);
  padding-top: 1px;
  margin-left: 0;
}
.rating-box ion-col {
  text-align: center;
}

ion-range {
  --bar-background: var(--ion-color-light);
  --bar-background-active: linear-gradient(to right, #FF8E14 calc(var(--bar-width) / 10), #ffe338 calc(var(--bar-width) / 100 * 55), #C2D61A calc(var(--bar-width) / 100 * 90));
  --bar-height: 10px;
  --bar-border-radius: 8px;
  --knob-background: white;
  --knob-border: 2px black solid;
  --knob-box-shadow: 0px 0px 0px 3px black;
  --knob-size: 18px;
  --pin-background: #ffafcc;
  --pin-color: #fff;
  height: 40px;
}

ion-icon {
  margin-left: unset;
  margin-right: unset;
  margin-inline: 13px 0;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
